import type { CollectionCard, GiftingFeature, GiftingOption, PageContent } from '../schema';

export const homeCollections = [
  {
    image: '/assets/optimized/home-collection-1.webp',
    alt: 'Silk saree with intricate gold border pattern',
  },
  {
    image: '/assets/optimized/home-collection-2.webp',
    alt: 'Close-up of Kanchipuram weaving technique',
  },
  {
    image: '/assets/optimized/home-collection-3.webp',
    alt: 'Modern silk design with contrast color palettes',
  },
] satisfies readonly CollectionCard[];

export const giftingFeatures = [
  {
    title: 'Customizable Saree Bundles',
    image: '/assets/optimized/editorial/home-concierge-curation.webp',
    link: '/wedding-gifting#bundles',
    altText: 'Ruby silk saree curated with jasmine, brass ritualware, and a personal note',
  },
  {
    title: 'Elegant Packaging',
    image: '/assets/optimized/editorial/home-concierge-packaging.webp',
    link: '/wedding-gifting#packaging',
    altText: 'Artisan wrapping a celebration gift in indigo paper with a red wax seal',
  },
  {
    title: 'Personalized Messages',
    image: '/assets/optimized/editorial/home-concierge-blessing.webp',
    link: '/wedding-gifting#personalization',
    altText: 'Calligrapher writing a gold blessing beside magenta ceremonial silk',
  },
] satisfies readonly GiftingFeature[];

export const giftingOptions = [
  {
    title: 'Customizable Saree Bundles',
    description:
      'Select heirloom-quality sarees, coordinate blouse fabrics, and layer in jewelry keepsakes curated for each ceremony.',
    image: '/assets/optimized/wedding/wedding-gifting-saree-hamper.webp',
    altText: 'Vibrant Kanchipuram saree hamper with jasmine garlands, jewelry boxes, and floating candles',
    badge: 'Signature Edit',
    turnaround: 'Lead time: 3-4 weeks',
  },
  {
    title: 'Heritage Dhoti Collections',
    description:
      'Curate veshti and angavastram ensembles with temple bells, sandalwood keepsakes, and ritual-ready botanicals.',
    image: '/assets/optimized/wedding/wedding-gifting-dhoti-set.webp',
    altText: 'Ivory veshti and angavastram set styled with brass bells, sandalwood boxes, and betel leaves',
    badge: 'Temple Rituals',
    turnaround: 'Lead time: 2-3 weeks',
  },
  {
    title: 'Personalized Keepsake Notes',
    description:
      'Collaborate with our calligraphy artists to script blessings on cotton rag paper, finished with wax seals and velvet ribbon.',
    image: '/assets/optimized/wedding/wedding-gifting-calligraphy-note.webp',
    altText:
      'Artisan hand-writing a wedding blessing on cotton rag paper with fountain pen, candles, and wax seal stamp',
    badge: 'Signature Scripts',
    turnaround: 'Lead time: 7-10 days',
  },
] satisfies readonly GiftingOption[];

export const homePageContent = {
  id: 'home',
  title: 'Sree Silks',
  description: 'Heritage silk sarees and wedding gifting experiences.',
  sections: [
    {
      id: 'hero',
      title: 'Exquisite Wedding Gifting & Collections',
      description:
        'Discover curated traditional Indian wedding gifts, silk sarees, and personalized gifting solutions.',
    },
    {
      id: 'testimonials',
      title: 'What Our Clients Say',
      description: 'Stories of elegance and satisfaction from our cherished customers.',
    },
  ],
} satisfies PageContent;
